module.exports = __webpack_public_path__ + "img/album08_10.ce3e3847.jpg";